import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import FlagIcon from '@mui/icons-material/Flag';
import CancelIcon from '@mui/icons-material/Cancel';
import { GridCellParams } from '@mui/x-data-grid';
import { Typography } from '@mui/material';

const PREFIX = 'StatusIndicator';

const classes = {
  legend: `${PREFIX}-legend`,
  ok: `${PREFIX}-ok`,
  alert: `${PREFIX}-alert`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`& .${classes.legend}`]: {
    display: 'flex',
    alignContent: 'flex-end',
    justifyContent: 'flex-start',
  },

  [`& .${classes.ok}`]: {
    color: theme.palette.success.main,
    marginRight: theme.spacing(1),
  },

  [`& .${classes.alert}`]: {
    color: theme.palette.error.main,
    marginRight: theme.spacing(1),
  },
}));

interface StatusIndicatorProps {
  cell: GridCellParams;
}

const Legend = ({ ctt }: { ctt: boolean }) => {
  const { t } = useTranslation('common');

  return (
    <StyledBox>
      <Box className={classes.legend} component="div">
        <FlagIcon className={classes.ok} />{' '}
        <Typography>
          {ctt ? t('common.statusClearToTransport') : t('common.active')}
        </Typography>
      </Box>
      <Box className={classes.legend} component="div">
        <CancelIcon className={classes.alert} />
        <Typography>
          {ctt ? t('common.statusNotClearToTransport') : t('common.inactive')}
        </Typography>
      </Box>
    </StyledBox>
  );
};

export default function StatusIndicator({ cell }: StatusIndicatorProps) {
  const ctt = cell.field === 'isClearToTransport';
  let value = false;
  if (ctt) {
    value = cell.value;
  } else {
    value =
      cell.row.transportationProviderState === 'active' ||
      cell.row.driverState === 'active' ||
      cell.row.vehicleState === 'active' ||
      cell.row.userAccountState === 'active' ||
      cell.row.IsActive; // TODO: this check can go away as soon as Provider, Driver and Vehicle data models are all ported
  }

  return (
    <StyledBox>
      <Tooltip title={<Legend ctt={ctt} />}>
        {value ? (
          <FlagIcon data-testid="flag" className={classes.ok} />
        ) : (
          <CancelIcon data-testid="flag" className={classes.alert} />
        )}
      </Tooltip>
    </StyledBox>
  );
}
